import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import axiosAuth from '../axiosAuth';
import { COMMUNITY_API } from './apiRoutes';

interface UseGetPaymentReportProps {
  communityId: string;
  data: any;
  queryParams?: Omit<UseQueryOptions, 'queryKey'>;
}

const getPaymentReport = async (communityId: string, data: any) =>
  await axiosAuth.post(`${COMMUNITY_API}/${communityId}/reports/budget-360`, data);

const useGetPaymentReport = ({
  communityId,
  data,
  queryParams,
}: UseGetPaymentReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ['payment-report', communityId, data],
    queryFn: () => getPaymentReport(communityId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPaymentReport;
